import StackAPI from '@/lib/StackAPI'
import Storage from '@/lib/Storage'
import { captureException } from '@sentry/react'

const PATH = '/partners/vendor/batches_orders_metrics'
const UNKNOWN_ERROR = 'Batch Metrics Update request has failed.'
const UNAUTHORIZED_ERROR = 'You are not authorized to update batch metrics.'

const submitBatchMetricsUpdate = async () => {
  const { put } = StackAPI()
  const { getActiveRole } = Storage()
  const vendorId = getActiveRole()?.id

  return put({ path: PATH, params: { vendor_id: vendorId } })
    .then(({ status }) => {
      if (status === 401) return { error: UNAUTHORIZED_ERROR }
      if (status < 200 || status >= 300) return { error: UNKNOWN_ERROR }
    })
    .catch((error) => {
      captureException(error)
      return { error: UNKNOWN_ERROR }
    })
}

export default submitBatchMetricsUpdate
